import { useNlmSearch } from "@/shared/hooks/use-nlm-search";

const NLM_API = "https://clinicaltables.nlm.nih.gov/api/loinc_items/v3/search";

export interface LoincCodeOption {
  code: string;
  display: string;
}

const searchConfig = {
  endpoint: NLM_API,
  params: "df=LOINC_NUM,LONG_COMMON_NAME",
  parse(data: [number, string[], null, string[][]]): LoincCodeOption[] {
    const codes = data[1] ?? [];
    const rows = data[3] ?? [];
    return codes.map((code, i) => ({ code, display: rows[i]?.[1] || code }));
  },
};

export function useLoincCodeSearch(query: string) {
  return useNlmSearch(query, searchConfig);
}
